import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  return new Observable<boolean>((observer) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        observer.next(true);
        observer.complete();
      } else {
        router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        observer.next(false);
        observer.complete();
      }
    });

    return () => unsubscribe();
  }).pipe(take(1));
};

